import React from "react";
import { SectionHeading } from "../SectionHeading";
import { CTAButton } from "../CTAButton";
import { practicalTools } from "../../data/sections";
export function ToolsSection() {
  return <section className="bg-brand px-5 py-16 sm:py-24" data-id="element-281" data-mp="1wsgr1u2ple2a">
      <SectionHeading tone="dark" kicker="Included in the system" title="And you'll also get these practical tools" data-id="element-282" data-mp="1wu1kthh78sz3" />

      <ul className="mx-auto mt-12 max-w-3xl divide-y divide-white/15" data-id="element-283" data-mp="1nzn7vlk55uj5">
        {practicalTools.map(({
        icon: Icon,
        title,
        text
      }) => <li key={title} className="flex gap-4 py-6 first:pt-0" data-id="element-284" data-mp="1srf0e1muyabx">
            <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-cream text-brand" data-id="element-285" data-mp="1e1h3mxav4cb4">
              <Icon className="h-6 w-6" aria-hidden="true" data-id="element-286" data-mp="1j0ajgwdmgfeg" />
            </span>
            <div data-id="element-287" data-mp="1iy7jbjir95w0">
              <h3 className="font-serif text-xl font-bold text-cream" data-id="element-288" data-mp="15117ya0d29gt">{title}</h3>
              <p className="mt-1 text-[17px] leading-relaxed text-cream/80" data-id="element-289" data-mp="15359wmep8yeg">{text}</p>
            </div>
          </li>)}
      </ul>

      <p className="mx-auto mt-10 max-w-2xl text-center text-lg leading-relaxed text-cream/90" data-id="element-290" data-mp="1rrymn6lrveoc">
        Whatever basic practice session you're organizing… you'll have a visual system you can return to whenever you need to know{" "}
        <strong className="text-cream" data-id="element-291" data-mp="21q63lpg29wqc">what to reference, what to follow, and what to record.</strong>
      </p>

      <CTAButton tone="dark" label="Yes! Give me the complete system" className="mt-10" data-id="element-292" data-mp="1wprt80qzmap5" />
    </section>;
}